import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const updateSubjectStatus = async ({ payload }) => {
  const token = localStorage.getItem("token");

  const response = await axios.patch(
    `${__API_URL__}/api/patient/patient/update_subject_status/`,
    payload,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return response.data;
};

const useUpdateSubjectStatusMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateSubjectStatus,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["single_patient"] });
    },
  });
};

export default useUpdateSubjectStatusMutation;
